export const STATUS_MAP = {
  pending: { cls: "badge-neutral", label: "Pending" },
  in_progress: { cls: "badge-info", label: "In Progress" },
  completed: { cls: "badge-success", label: "Completed" },
  cancelled: { cls: "badge-neutral", label: "Cancelled" },
  blocked: { cls: "badge-danger", label: "Blocked" },
  open: { cls: "badge-warning", label: "Open" },
  resolved: { cls: "badge-success", label: "Resolved" },
  closed: { cls: "badge-neutral", label: "Closed" },
};

export function StatusBadge({ status }) {
  const m = STATUS_MAP[status] || { cls: "badge-neutral", label: status || "—" };
  return (
    <span className={`badge ${m.cls}`}>
      <span className="badge-dot" />
      {m.label}
    </span>
  );
}

// Orthogonal overlay flag — a task can be in any active status AND waiting on
// the client. Shown alongside (below) the StatusBadge.
export function ClientPendingBadge() {
  return (
    <span className="badge badge-warning" title="Waiting on inputs from the client">
      Client pending
    </span>
  );
}

const PRIORITY_MAP = {
  low: "badge-neutral",
  medium: "badge-info",
  high: "badge-warning",
  urgent: "badge-danger",
};

export function PriorityBadge({ priority }) {
  return (
    <span className={`badge ${PRIORITY_MAP[priority] || "badge-neutral"}`}>
      {priority || "—"}
    </span>
  );
}

// Task priority (low / medium / high) — used in the task drawer and task
// tables. Applies to both one-off and recurring tasks (recurring instances
// inherit the priority set on the business ↔ task pivot at attach time).
const TASK_PRIORITY = {
  low: { cls: "badge-neutral", label: "Low" },
  medium: { cls: "badge-warning", label: "Medium" },
  high: { cls: "badge-danger", label: "High" },
};

export function TaskPriorityBadge({ priority }) {
  const m = TASK_PRIORITY[priority] || { cls: "badge-neutral", label: priority || "—" };
  return <span className={`badge ${m.cls}`}>{m.label}</span>;
}
